/// <amd-module name="Environments/EnvironmentChecks/ActionsCreators/EnvironmentChecksActionsCreator" />
import { ActionCreatorBase } from "Environments/Flux/ActionCreatorBase";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { MessagesActions } from "Environments/EnvironmentsCommon/MessagesActions";

import { IEnvironmentService } from "Environments/Client/EnvironmentService";
import * as Contracts from "DistributedTask/Client/Contracts/TaskAgent";
import { IVssPageContext } from "VSS/Platform/Context";
import { EnvironmentChecksActions } from "Environments/EnvironmentChecks/Actions/EnvironmentChecksActions";

export const EnvironmentChecksPageKey = "environment-checks";

export class EnvironmentChecksActionsCreator extends ActionCreatorBase {
    public static getKey(): string {
        return "environment-checks-action-creator";
    }

    public initialize(instanceId?: string) {
        super.initialize(instanceId);

        this._actions = ActionsHubManager.CreateActionsHub<EnvironmentChecksActions>(EnvironmentChecksActions, instanceId);
        this._messageActions = ActionsHubManager.CreateActionsHub<MessagesActions>(MessagesActions, instanceId);
    }

    public getEnvironmentById(pageContext: IVssPageContext, environmentId: number, includeSGReferences: boolean = true) {
        const expands: Contracts.EnvironmentExpands = includeSGReferences ? Contracts.EnvironmentExpands.ResourceReferences : Contracts.EnvironmentExpands.None;
        pageContext.getService<IEnvironmentService>("IEnvironmentService").getEnvironmentById(environmentId, expands).then((environment: Contracts.EnvironmentInstance) => {
            this._actions.setEnvironment.invoke(environment);
        },
        (error) => {
            this._messageActions.addMessage.invoke({ key: EnvironmentChecksPageKey, value: error.message || error });
        });
    }

    protected disposeInternal(): void {
        ActionsHubManager.DeleteActionsHub<EnvironmentChecksActions>(EnvironmentChecksActions, this.getInstanceId());
        ActionsHubManager.DeleteActionsHub<MessagesActions>(MessagesActions, this.getInstanceId());
    }

    private _actions: EnvironmentChecksActions;
    private _messageActions: MessagesActions;
}
